import styled from 'styled-components';

export const CellContent = styled.div.attrs<{ className?: string }>({ className: 'md:h-[60px]' })`
  margin: 0;
  display: flex;
  align-items: center;
`;
